import React from "react";

import Banner from "../components/Banner";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import landingAsset from "../utils/assetPaths";

interface PrivacyBlock {
    title: string;
    items: string[];
}

const Privacy: React.FC = () => {
    return (
        <>
            <Navbar />
            <div
                style={{
                    backgroundImage: `url(${landingAsset("herobg.svg")})`,
                    backgroundSize: "cover",
                }}
                className="h-[500px] md:h-[400px] relative w-full flex justify-center items-center flex-col "
            >
                <div
                    style={{
                        background:
                            "linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 17.83%)",
                    }}
                    className=" h-full w-full absolute left-0 top-0"
                >
                    <div className=" w-full h-full flex flex-col items-center text-center justify-center p-4">
                        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-black font-Manrope uppercase tracking-tight">Privacy Policy</h1>
                        <p className=" mt-6 text-center font-Manrope text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
                            At SACA, we value your privacy and are committed to protecting
                            your personal information. This policy outlines how we handle your data.
                        </p>
                    </div>
                </div>
            </div>

            <div className=" flex flex-col py-20 w-full px-4 md:px-14 bg-white">
                <div className="max-w-4xl mx-auto w-full">
                    <div className="font-Manrope space-y-16 w-full">
                        <section className="space-y-8">
                            <div className="space-y-4">
                                <h2 className="text-3xl font-black text-gray-900 border-l-8 border-green-700 pl-6">Information We Collect</h2>
                                <p className="text-lg text-gray-500 font-medium">We gather essential data to provide and improve our sports community services.</p>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {[
                                    { title: "Personal Data", items: ["Full name & gender", "Email & phone", "Profile picture"] },
                                    { title: "Usage Data", items: ["Booking history", "Match attendance", "Platform activity"] },
                                    { title: "Payment Info", items: ["Secured transaction data", "Payment history", "Plan status"] },
                                    { title: "Location", items: ["Nearby games", "Preferred pitches", "Regional events"] }
                                ].map((block: PrivacyBlock, i) => (
                                    <div key={i} className="p-8 bg-gray-50 rounded-3xl border border-gray-100 hover:shadow-lg transition-all">
                                        <h4 className="font-black text-xl text-gray-900 mb-4">{block.title}</h4>
                                        <ul className="space-y-2">
                                            {block.items.map((item, j) => (
                                                <li key={j} className="flex items-center gap-2 text-gray-600 font-medium">
                                                    <span className="w-1.5 h-1.5 rounded-full bg-green-700" />
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </div>
                        </section>

                        <section className="space-y-8">
                            <h2 className="text-3xl font-black text-gray-900 border-l-8 border-green-700 pl-6">Data Protection</h2>
                            <div className="p-10 bg-green-700 rounded-[40px] text-white shadow-2xl relative overflow-hidden group">
                                <div className="absolute -right-10 -top-10 w-40 h-40 bg-white/10 rounded-full group-hover:scale-150 transition-transform duration-700" />
                                <p className="text-xl md:text-2xl font-bold leading-relaxed relative z-10 italic">
                                    "We use bank-grade encryption (SSL), hardened databases, and strict access controls. Your information is never sold or shared without consent, except as required by law."
                                </p>
                            </div>
                        </section>

                        <section className="space-y-8">
                            <div className="space-y-4">
                                <h2 className="text-3xl font-black text-gray-900 border-l-8 border-green-700 pl-6">Your Rights</h2>
                                <p className="text-lg text-gray-500 font-medium">You maintain full control over your digital footprint on SACA.</p>
                            </div>
                            <div className="flex flex-wrap gap-4">
                                {["Access & Edit Data", "Account Deactivation", "Notification Opt-out", "Data Deletion"].map((tag, i) => (
                                    <span key={i} className="px-6 py-3 rounded-2xl bg-gray-100 text-gray-900 font-black text-lg">
                                        {tag}
                                    </span>
                                ))}
                            </div>
                        </section>

                        <div className="mt-16 pt-16 border-t border-gray-100 text-center">
                            <h3 className="text-2xl font-black text-gray-900 mb-6">Contact Privacy Team</h3>
                            <a href="mailto:support@saca.com.ng" className="px-10 py-4 bg-gray-900 text-white rounded-2xl font-black text-lg inline-block hover:bg-black transition-colors shadow-xl active:scale-95">
                                support@saca.com.ng
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <Banner />
            <Footer />
        </>
    );
};

export default Privacy;
